/**
 * Single Org-row cue while registration content is refreshing or soft-deferring.
 * Prefer pendingPlaylistSwap (“preparando / troca”) over the receiving placeholder
 * so the row advances as one continuous Atualiz. journey (no blank gap).
 */

import type { TPendingPlaylistSwapOverlayInput } from '@/helpers/resolvePendingPlaylistSwapOverlayLine'
import { resolvePendingPlaylistSwapOverlayLine } from '@/helpers/resolvePendingPlaylistSwapOverlayLine'
import { resolveRegistrationStatusRefreshOverlayLine } from '@/helpers/resolveRegistrationStatusRefreshOverlayLine'

export type TContentChangeStatusOverlayLine = {
  /** Stable key for Vue transition (receiving vs swap phase). */
  key: string
  label: string
  value: string
  tone: 'normal' | 'warning' | 'info'
}

export function resolveContentChangeStatusOverlayLine(options: {
  registrationStatusRefreshPending: boolean
  pendingPlaylistSwap: TPendingPlaylistSwapOverlayInput | null
  /** Keep Recebendo while GET/worker identity is ahead of on-air Feed (no blank gap). */
  registrationAheadOfPlayback?: boolean
  /** Wall clock for ETA countdown (CurrentState tickEpochMs). */
  nowMs?: number
}): TContentChangeStatusOverlayLine | null {
  const nowMs = options.nowMs ?? Date.now()
  const swap = options.pendingPlaylistSwap
  if (swap != null) {
    const line = resolvePendingPlaylistSwapOverlayLine(swap, nowMs)
    return {
      key: `swap:${swap.phase}`,
      label: line.label,
      value: line.value,
      tone: line.tone
    }
  }
  const receiving = resolveRegistrationStatusRefreshOverlayLine(
    options.registrationStatusRefreshPending || options.registrationAheadOfPlayback === true
  )
  if (receiving == null) {
    return null
  }
  return {
    key: 'receiving',
    label: receiving.label,
    value: receiving.value,
    tone: 'info'
  }
}
